import React, { useEffect, useState } from 'react'
import InputAdornment from '@material-ui/core/InputAdornment'
import { useDispatch, useSelector } from 'react-redux'
import { selectStripePaymentData } from '../../../store/selectors/App'
import {
  createPaymentIntent,
  setClientSecret,
} from '../../../store/entities/App/App.actions'
import { loadStripe } from '@stripe/stripe-js/pure'
import { useHistory } from 'react-router-dom'
import URLS from '../../../config/navigation'
import { ALIPAY, WE_CHAT_PAY } from '../../../config/stripe'
import Description from '../../Common/Typography/description'
import ImageButton from '../../Common/Buttons/imageButton'
import TextBox from '../../Common/Textbox/small'
import { ReactComponent as WeChatIcon } from '../../../assets/img/wechat.svg'
import { ReactComponent as AliPayIcon } from '../../../assets/img/alipay.svg'
import '../../../styles/main.css'
import Toast from '../../Common/Toast'
import ToastMessage from '../../Common/ToastMessage'
import { ReactComponent as SVG } from '../../../assets/img/how-to-scan.svg'
import { Formik, Form, ErrorMessage } from 'formik'
import * as Yup from 'yup'

const PaymentContainer = ({ profileUrl, handleLoading }) => {
  const dispatch = useDispatch()
  const { clientSecret, stripePaymentIntentId } = useSelector(selectStripePaymentData)
  const [loading, setLoading] = useState(false)
  const [paymentMethodType, setPaymentMethodType] = useState('alipay')

  const history = useHistory()

  //Payment validation Schema
  const paymentSchema = Yup.object().shape({
    name: Yup.string().required('必需的'),
    amount: Yup.number().moreThan(0.5, '最低缴费金额为4元').required('必需的'),
  })

  //If clientSecret Exists, process payment immediately
  useEffect(() => {
    if(clientSecret) {
      submitPayment();
    }
  }, [clientSecret])



  const handleCreatePaymentIntent = async (values) => {
    if (values.amount && values.amount > 0) {
      setLoading(true)
      handleLoading(true)
      setPaymentMethodType(values.paymentMethodType)
      const url = profileUrl.toLowerCase()
      const stripeResponse = await dispatch(
        createPaymentIntent({
          amount: values.amount,
          name: values.name,
          profileUrl: url,
          paymentMethodType: values.paymentMethodType
        })
      )

      if (stripeResponse.error){
        Toast(ToastMessage(values.paymentMethodType), 'warning')
        setLoading(false)
        handleLoading(false)
      }
      
    } else {
      Toast(ToastMessage(6), 'warning')
    }
  }

  const submitPayment = async () => {
    try {
      const stripe = await loadStripe(
        `${process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY}`
      )
      localStorage.setItem('profileUrl', profileUrl.toLowerCase())
      let payment = null

      switch (paymentMethodType) {
        case WE_CHAT_PAY: {
          const {err} = await stripe.confirmWechatPayPayment(clientSecret, {
            payment_method_options: {
              wechat_pay: {
                client: 'web',
              },
            },
          })
        if(err){
          Toast(ToastMessage(15), 'warning')
        }
          break
        }
        case ALIPAY: {
          payment = await stripe
            .confirmAlipayPayment(clientSecret, {
              return_url: `${window.location.href}`,
            })
            .then((result) => {
              if (result.error) {
                // Inform the customer that there was an error.
                console.log(result.error.message)
                Toast(result.error.message, 'warning')
              }
            })
            break
        }
      }
      //Remove clientSecret
      dispatch(setClientSecret(null, null, null))
      setLoading(false)
      handleLoading(false)
    } catch (e) {
      setLoading(false)
      handleLoading(false)
      Toast(JSON.stringify(e), 'warning')
    }
  }

  return (
    <Formik
      initialValues={{ name: '', amount: '', paymentMethodType: '' }}
      validationSchema={paymentSchema}
      onSubmit={ async (values)=>{
        //alert(JSON.stringify(values))
        await handleCreatePaymentIntent(values)
 
      }}
    >
      {({ errors, touched, setFieldValue, handleChange }) => (
        <Form>
          <div className={'paymentContainer'}>
            <div className={'paymentWrapper'}>
              <Description
                addClass={'BOLD_STYLE span'}
                text={`请输入您要支付的金额（美元）`}
              />
              <div className={'infoContainer'}>
                <div className={'inputContainer'}>
                  <TextBox
                    loading={loading}
                    placeholder=''
                    error={false}
                    type={'text'}
                    handleChange={handleChange}
                    tName={'name'}
                    label={'学生姓名'}
                    additionClass={'EMPHASIS_LARGE smallInput'}
                    htmlFor='outlined-basic-name'
                  />
                  {errors.name && touched.name ? (
                    <div className={'error'}>{errors.name}</div>
                  ) : (
                    <div className={'error'}></div>
                  )}
                </div>
                <div style={{ width: '32px' }} />
                <div className={'inputContainer inputAmount'}>
                  <TextBox
                    loading={loading}
                    placeholder=''
                    error={false}
                    type={'number'}
                    handleChange={handleChange}
                    tName={'amount'}
                    label={'数额 (美元)'}
                    additionClass={'EMPHASIS_LARGE smallInput'}
                    htmlFor='outlined-basic-amount'
                    InputProps={{
                      step: .01,
                      endAdornment: (
                        <InputAdornment
                          className={'endadornment'}
                          position='end'
                        >
                          $
                        </InputAdornment>
                      ),
                    }}
                  />
                  {errors.amount && touched.amount ? (
                    <div className={'error'}>{errors.amount}</div>
                  ) : (
                    <div className={'error'}></div>
                  )}
                </div>
              </div>
              <div className={'paymentButtonsContainer'}>
                <ImageButton
                  loading={loading}
                  additionClass={'bg-light-green'}
                  text={`使用微信支付`}
                  Icon={<WeChatIcon fill="#fff" />}
                  handleClick={ () => {
                    setFieldValue('paymentMethodType', 'wechat_pay')
                  }}
                ></ImageButton>
                <ImageButton
                  loading={loading}
                  additionClass={'bg-light-blue'}
                  text={`支付宝支付`}
                  Icon={<AliPayIcon fill='#fff' />}
                  handleClick={ () => {
                    setFieldValue('paymentMethodType', 'alipay')
                  }}
                ></ImageButton>
              </div>
              <div className={'descriptionContainer'}>
                <Description
                  addClass={'BODY_MEDIUM SECONDARY_60 center-text'}
                  text={
                    '您需要使用一个设备，按“微信支付”按钮以打开二维码，然后使用手机扫描生成的二维码'
                  }
                />
                <Description
                  addClass={'BODY_MEDIUM SECONDARY_60 center-text'}
                  text={'我们的支付系统不支持手机截图或长按二维码进行支付'}
                />
              </div>
              <SVG className='svg' />
            </div>
          </div>
        </Form>
      )}
    </Formik>
  )
}
export default PaymentContainer
